import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../../common/src/stores/CollectionStore";
import { QuiltyResourceListItem } from "@gsx/common/src/types/http/admin/quiltyResource";

@Module()
export class QuiltyResourceCollectionStore extends CollectionStore<QuiltyResourceListItem> {
    sort: keyof QuiltyResourceListItem = "title";
}
